import React from 'react';
import Router from './router/Router';

export default function App() {
  return (
    <div>
      <Router />
    </div>
  );
}
